export var NotificationInfoType;
(function (NotificationInfoType) {
    NotificationInfoType["Update"] = "update";
    NotificationInfoType["Text"] = "text";
})(NotificationInfoType || (NotificationInfoType = {}));
